import "./Home.css";
import usePageMeta from "../../hooks/usePageMeta";
import mpHome from "../../assets/mp-home-1.png";
import mpHome2 from "../../assets/mp-home-2.png";
import mpHome3 from "../../assets/mp-home-3.png";
import mpHome4 from "../../assets/mp-home-4.png";

export default function Home() {
  usePageMeta(
    "Bitcoin-Backed Loans | Borrow Against BTC at 0% Interest",
    "Borrow against Bitcoin at 0% interest with Money Protocol. Get instant liquidity without selling BTC while keeping your assets secure & benefiting from growth.",
    "https://www.moneyprotocol.co/",
  );
  const handleLaunchNow = () => {
    window.open(
      "https://www.bitcoinstable.money/",
      "_blank",
      "noopener,noreferrer",
    );
  };
  return (
    <>
      <div className="parallax-section" id="home">
        <div className="container text-center">
          <h1 className="display-4 header-title">
            0% Interest Loan, &nbsp; 100% Backed by Bitcoin
          </h1>
          <p className="lead">
            Borrow against your own Bitcoin at 0% interest.
          </p>
          <button className="btn  launch-button" onClick={handleLaunchNow}>
            <span className="launch-now-text">Launch Now</span>
          </button>
        </div>
      </div>

      {/* About Section */}
      <div
        className="container bg-white text-center curved p-0 card-parent-container"
        id="about"
      >
        <div className="row mr-auto">
          <div className="col-md-6 p-0">
            <img
              src={mpHome}
              alt="Borrow against your Bitcoin"
              className="curved-card"
              style={{ width: "100%" }}
            ></img>
          </div>
          <div className="col-md-6 p-0 align-content-center card-container">
            <h2 className="card-header">Let your Bitcoin work for you.</h2>
            <p className="card-desc m-0 mt-5">
              Borrow against your Bitcoin and pay a 0% annual interest rate for
              as long as you have your loan and maintain a 110% minimum
              collateral ratio. All you pay is a one-time fee when you take out
              the loan. No variable borrow interest rate, ever.
            </p>
          </div>
        </div>
      </div>

      {/* Parallax Section 2 */}
      <div
        className="container text-center curved p-0 card-parent-container mt-86px"
        id="about"
      >
        <div className="row ml-auto">
          <div className="col-md-6 p-0 align-content-center card-container">
            <h2 className="card-header">
              Backed by Bitcoin and fully transparent unstoppable stable money.
            </h2>
            <p className="card-desc m-0 mt-5">
              Sound money is now also stable unstoppable money. BPD is the
              USD-pegged stablecoin that you receive when you borrow against
              your Bitcoin. As BPD is derived from Bitcoin it is censorship
              resistant like Bitcoin. Anyone can use BPD anywhere at any time.
            </p>
          </div>
          <div className="col-md-6 p-0">
            <img
              src={mpHome2}
              alt="Bitcoin Backed Loan"
              className="curved-card-right"
              style={{ width: "100%" }}
            ></img>
          </div>
        </div>
      </div>

      {/* About Section */}
      <div
        className="container bg-white text-center curved p-0 card-parent-container mt-86px"
        id="about"
      >
        <div className="row mr-auto">
          <div className="col-md-6 p-0">
            <img
              src={mpHome3}
              alt="BTC Collateral Borrowing"
              className="curved-card"
              style={{ width: "100%" }}
            ></img>
          </div>
          <div className="col-md-6 p-0 align-content-center card-container">
            <h2 className="card-header">Hodl and Live</h2>
            <p className="card-desc m-0 mt-5">
              Unlock the value of your Bitcoin without selling it. With a 110%
              minimum collateralization ratio, Money Protocol is a decentralized
              capital-efficient way of borrowing from BTC and maintaining
              custody over your BTC. Pay back the loan on your own terms as
              there is no payback period. And at a 0% interest rate, don’t just
              hodl, hodl and live.
            </p>
          </div>
        </div>
      </div>

      {/* Parallax Section 2 */}
      <div
        className="container text-center curved p-0 card-parent-container mt-86px"
        id="about"
      >
        <div className="row ml-auto">
          <div className="col-md-6 p-0 align-content-center card-container">
            <h2 className="card-header">A System of Rules, Not Rulers.</h2>
            <p className="card-desc m-0 mt-5">
              Like Bitcoin, no one owns or controls Money Protocol. It has no
              Governance making changes to its rules. It is immutable and using
              Money Protocol is non-custodial.
            </p>
          </div>
          <div className="col-md-6 p-0">
            <img
              src={mpHome4}
              alt="Immutable DeFi Protocol"
              className="curved-card-right"
              style={{ width: "100%" }}
            ></img>
          </div>
        </div>
      </div>
    </>
  );
}
